import {AuthGuard} from '../../../shared/services';
import {AssociationsListComponent} from './associations-list.component';
import {CategoryAssociationsResolver} from './category-associations.resolver';
import {Route} from '@angular/router';

export const AssociationsListRoutes: Route[] = [
  {
    path: 'list',
    component: AssociationsListComponent,
    canActivate: [AuthGuard],
    resolve: {
      categories: CategoryAssociationsResolver
    }
  }
];
